import MgoTextField from '@humanforce/mango-ui/dist/react/text-field/index.js';
import { asMangoElement } from './mango';

const MangoTextField = asMangoElement(MgoTextField);

interface TextFieldProps {
  id: string;
  label: string;
  value: string;
  disabled?: boolean;
  helpText?: string;
  readOnly?: boolean;
  status?: 'critical' | 'positive' | 'caution';
  statusText?: string;
  type?: string;
  onChange?: (value: string) => void;
}

export const TextField = ({ disabled, helpText, id, label, onChange, readOnly, status, statusText, type = 'text', value }: TextFieldProps) => {
  const handleInput = (event: Event) => {
    const target = event.target as HTMLElement & { value?: string };
    const detail = (event as CustomEvent<{ value?: string }>).detail;
    onChange?.(detail?.value ?? target.value ?? '');
  };

  return (
    <MangoTextField
      disabled={disabled ? true : undefined}
      helpText={helpText}
      id={id}
      label={label}
      onMgoInput={handleInput}
      readonly={readOnly ? true : undefined}
      status={status}
      statusText={statusText}
      type={type}
      value={value}
    />
  );
}
